module.exports = __webpack_public_path__ + "55a2fdb0eb00c703f0306d8858519073.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_small_x1/public/news/temp.jpg
// module id = 316
// module chunks = 0